import { render, staticRenderFns } from "./DispatchAlarmModal.vue?vue&type=template&id=b913a73a"
import script from "./DispatchAlarmModal.vue?vue&type=script&lang=js"
export * from "./DispatchAlarmModal.vue?vue&type=script&lang=js"
import style0 from "./DispatchAlarmModal.vue?vue&type=style&index=0&id=b913a73a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports